var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0172 26.4182L32.9966 32.9877L29.03 31.9446L35.0172 26.4182Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.03 31.9446L32.8558 26.904L35.0172 26.4182L29.03 31.9446Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0442 21.4652L35.0171 26.4183L32.8557 26.904L32.0442 21.4652ZM32.0442 21.4652L33.9571 20.1912L35.0171 26.4183L32.0442 21.4652Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6097 17.7226L35.1083 15.5566L34.835 16.7431L29.6097 17.7226ZM34.6611 18.1685L29.6097 17.7226L34.835 16.7431L34.6611 18.1685Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6611 18.1685L33.9572 20.1911L29.6097 17.7226L34.6611 18.1685ZM35.7625 16.0583L34.835 16.7431L35.1083 15.5566L35.7625 16.0583ZM34.6611 18.1685L34.835 16.7431L35.572 17.3324L34.6611 18.1685Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7653 30.344L26.14 30.766L29.0301 31.9446L24.7653 30.344Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.190386
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9573 20.1912L34.6612 18.1686L35.2657 18.6145L33.9573 20.1912ZM33.9573 20.1912L28.2517 18.3836L29.6098 17.7227L33.9573 20.1912Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9679 11.5194L29.6098 17.7226L28.2517 18.3836L30.9679 11.5194Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1083 15.5567L29.6097 17.7226L30.9678 11.5194L35.1083 15.5567Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9677 11.5194L36.7064 10.8823L35.1082 15.5566L30.9677 11.5194Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9573 20.1912L32.0444 21.4652L28.2517 18.3835L33.9573 20.1912Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.458 6.41504L36.7064 10.8823L30.9677 11.5194L36.458 6.41504Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.458 6.41504L24.9888 14.4338L24.8397 8.99507L36.458 6.41504Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.190386
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3104 8.34216L24.8399 8.99513L24.989 14.4339L16.3104 8.34216Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2516 18.3836L24.9889 14.4339L30.9678 11.5194L28.2516 18.3836Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2516 18.3835L32.0443 21.4652L26.7196 22.0306L28.2516 18.3835Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7196 22.0306L24.9889 14.4338L28.2516 18.3835L26.7196 22.0306Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9678 11.5194L24.9889 14.4338L36.4581 6.41504L30.9678 11.5194Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3849 31.8173L19.0928 34.5327L15.4077 31.3076L16.3849 31.8173Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.190386
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.03 31.9447L30.3135 27.2544L32.8558 26.9041L29.03 31.9447Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40411 18.7499L10.0912 14.0118L6.00863 18.1845L5.40411 18.7499Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.190386
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.856 26.904L30.3137 27.2544L32.0444 21.4653L32.856 26.904ZM24.989 14.4339L20.4261 14.2906L16.3104 8.34216L24.989 14.4339Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0444 21.4652L30.3136 27.2543L30.1729 24.4275L32.0444 21.4652Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.190386
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7196 22.0306L32.0443 21.4652L30.1728 24.4275L26.7196 22.0306Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.426 14.2905L24.9888 14.4339L26.7196 22.0306L20.426 14.2905Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.426 14.2905L8.1121 3.33337L16.3103 8.34213L20.426 14.2905ZM16.302 33.4815L5.60294 36.6667L3.46643 28.8231L16.302 33.4815Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99408 20.7088L11.0352 17.6589L14.4222 18.4154L6.99408 20.7088Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 18.4154L11.0352 17.6589L12.8487 10.4603L14.4221 18.4154Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00848 18.1845L11.0351 17.6589L6.99393 20.7088L6.00848 18.1845Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1728 24.4275L28.086 23.4162L26.7196 22.0306L30.1728 24.4275Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00879 18.1844L5.65271 16.3768L11.0354 17.6589L6.00879 18.1844Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6555 25.6936L28.0861 23.4161L30.1729 24.4274L27.6555 25.6936Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.190386
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3137 27.2544L27.6555 25.6936L30.1729 24.4275L30.3137 27.2544Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0353 17.6589L5.65258 16.3769L5.21368 14.8559L11.0353 17.6589ZM12.8488 10.4603L11.0353 17.6589L5.21368 14.8559L12.8488 10.4603ZM12.8488 10.4603L20.426 14.2906L14.4222 18.4154L12.8488 10.4603Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 18.4154L20.4259 14.2905L23.1007 22.1501L14.4221 18.4154ZM23.1007 22.1501L14.803 21.9828L14.4221 18.4154L23.1007 22.1501Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99408 20.7087L14.4222 18.4154L14.8031 21.9828L6.99408 20.7087ZM26.7195 22.0306L23.1007 22.1501L20.4259 14.2905L26.7195 22.0306Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.086 23.4162L27.6554 25.6937L26.7196 22.0306L28.086 23.4162Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11224 3.33337L20.4262 14.2905L12.849 10.4603L8.11224 3.33337Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46643 28.8231L13.8509 28.4091L16.302 33.4815L3.46643 28.8231Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3021 33.4815L13.8509 28.4091L18.952 28.1702L16.3021 33.4815Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6554 25.6936L30.3136 27.2544L31.7793 30.575L27.6554 25.6936ZM14.8032 21.9828L3.46643 28.8231L6.99416 20.7087L14.8032 21.9828ZM13.8509 28.409L3.46643 28.8231L14.8032 21.9828L13.8509 28.409ZM26.7196 22.0306L27.3986 24.4036L24.1194 24.5867L26.7196 22.0306ZM24.1194 24.5867L23.1008 22.1501L26.7196 22.0306L24.1194 24.5867Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0927 34.5326L16.302 33.4814L26.0074 35.0502L19.0927 34.5326Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.190386
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99408 20.7087L5.40411 18.7498L6.00863 18.1844L6.99408 20.7087Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1088 33.8876L26.0074 35.0502L16.302 33.4814L27.1088 33.8876Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.190386
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6305 31.0369L16.302 33.4815L18.9519 28.1702L27.6305 31.0369Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.190386
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 33.4815L27.6305 31.0369L27.1088 33.8876L16.302 33.4815Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.190386
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21359 14.8559L4.84094 8.7323L12.8487 10.4603L5.21359 14.8559ZM6.00857 18.1844L4.90719 17.1094L5.65248 16.3768L6.00857 18.1844Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2458 23.7267L23.1007 22.15L22.8358 26.0041L21.2458 23.7267Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1007 22.15L21.2457 23.7267L18.5461 25.0725L23.1007 22.15Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7794 30.575L31.2743 30.2166L27.6555 25.6936L31.7794 30.575Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5464 25.0725L14.8033 21.9828L23.101 22.15L18.5464 25.0725Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.190386
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8358 26.0041L23.1007 22.15L24.1193 24.5867L22.8358 26.0041Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.190386
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54297 15.4611L5.21373 14.856L5.65263 16.3769L4.54297 15.4611Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8357 26.0041L18.5461 25.0724L21.2457 23.7267L22.8357 26.0041Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.190386
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8487 10.4603L4.84094 8.73232L8.11195 3.33337L12.8487 10.4603Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.190386
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0073 35.0502L26.4628 36.2446L19.0927 34.5326L26.0073 35.0502Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.190386
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9519 28.1701L18.5461 25.0725L22.8357 26.0042L18.9519 28.1701Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8033 21.9828L18.5464 25.0725L18.9521 28.1701L14.8033 21.9828Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.190386
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1194 24.5867L27.3987 24.4036L31.2742 30.2166L24.1194 24.5867ZM14.8032 21.9828L18.952 28.1701L13.8509 28.409L14.8032 21.9828Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1193 24.5868L28.1936 30.5511L22.8358 26.0042L24.1193 24.5868Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.190386
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8358 26.0042L28.1936 30.5511L27.6305 31.0368L22.8358 26.0042Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6305 31.0369L18.952 28.1702L22.8358 26.0042L27.6305 31.0369ZM31.2742 30.2167L28.1936 30.5511L24.1193 24.5868L31.2742 30.2167Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.190386
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0859 33.0197L30.7609 35.5758L26.4631 36.2447L32.0859 33.0197ZM26.4631 36.2447L26.0076 35.0502L27.109 33.8876L26.4631 36.2447Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.190386
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1088 33.8876L27.9204 33.5771L26.4629 36.2447L27.1088 33.8876ZM26.4629 36.2447L27.9204 33.5771L32.0857 33.0197L26.4629 36.2447Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.190386
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2743 30.2167L32.2929 30.8139L29.1957 31.1722L31.2743 30.2167Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.190386
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1955 31.1722L28.1935 30.5511L31.2741 30.2167L29.1955 31.1722ZM28.8395 31.6421L32.6073 31.2041L32.0856 33.0197L28.8395 31.6421Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.190386
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0858 33.0196L27.9204 33.577L28.8396 31.642L32.0858 33.0196ZM27.9204 33.577L27.1089 33.8876L27.6306 31.0368L27.9204 33.577ZM27.6306 31.0368L28.1937 30.551L29.1957 31.1721L27.6306 31.0368ZM32.2928 30.8138L32.6075 31.204L28.8396 31.642L32.2928 30.8138Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.190386
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8395 31.642L29.1955 31.1722L32.2927 30.8138L28.8395 31.642ZM27.6304 31.0368L28.8395 31.642L27.9203 33.577L27.6304 31.0368Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.190386
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1956 31.1722L28.8395 31.642L27.6304 31.0369L29.1956 31.1722Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.190386
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.b1bcf37024ccadea35dcaa5c51d3a350.svg";
export { ForwardRef as ReactComponent };